<ul>
  <li>
    <a
      class="go-back"
      [routerLink]="goBackRouteLink">
      <i class="material-icons material-symbols-rounded">chevron_left</i> {{ goBackToMessage }}</a
    >
  </li>
</ul>
